export const getErrorMessage = (error) =>
  error?.response?.data?.errors[0].message || error.toString();
